import React, { useState, useEffect, useRef, createRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { numberWithCommas } from "../../../utils/helpers";
import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  List,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  ShoppingCartOutlined,
  DeleteOutlined,
  QrcodeOutlined,
} from "@ant-design/icons";

import "./styles.scss";
import Beep from "./Beep.mp3";
import successfx from "./success.mp3";
import errorfx from "./error.mp3";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import { getProduct, setPrice } from "../../../Redux/actions/productActions";
import { setProductInventoryWithLocation } from "../../../Redux/actions/inventoryActions";
import {
  addCartItem,
  getCart,
  deleteCartItem,
  editCartItem,
  clearCart,
} from "../../../Redux/actions/cartActions";
import {
  createPackageFromItems,
  getPackageData,
  retrievePackage,
  readyShip,
  completePackage,
} from "../../../Redux/actions/packageActions";

import { errorParser, camelToSentence } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import InputSelect from "../../Generic/InputSelect";
import ImageChecker from "../../Generic/ImageChecker";
import ShipPackage from "../ShipPackage";
import useSound from "use-sound";
import ErrorList from "antd/lib/form/ErrorList";

import QRcomponent from "./qrcomponent";
import HQInboundScanner from "./HQInboundScanner";
import HQOutboundScanner from "./HQOutboundScanner";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({ onCloseModal, showButton }) => {
  const dispatch = useDispatch();
  const { user, cart, locations } = useSelector(
    (state) => ({
      user: state.auth.user,
      cart: state.cart.data,
      locations: state.locations.locations,
    }),
    shallowEqual
  );

  const [playbeep] = useSound(Beep);
  const [playsuccess] = useSound(successfx);
  const [playerror] = useSound(errorfx);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalWidth, setmodalWidth] = useState("80%");
  const [loading, setLoading] = useState(false);
  const [scanLoading, setScanLoading] = useState(false);

  const [setProccessloading, setSetProccessLoading] = useState(false);

  const [destination, setDestination] = useState(null);
  const [destinationName, setDestinationName] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);

  const [packItems, setPackItems] = useState([]);

  const [currentPackID, setCurrentPackID] = useState(null);
  const [currentScanned, setCurrentScanned] = useState(null);

  const [scannedItems, setScannedItems] = useState([]);
  const [kulang, setKulang] = useState(false);
  const [allScanned, setAllScanned] = useState(false);
  const [cameraID, setCameraID] = useState(null);
  const [cameras, setCameras] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);
  const [scanMode, setScanMode] = useState("package");
  const [hqInboundItems, setHqInboundItems] = useState({});
  const [hqOutboundItems, setHqOutboundItems] = useState({});
  const [hqOutboundDestination, setHqOutboundDestination] = useState(null);
  const [hqOutboundDestinationName, setHqOutboundDestinationName] =
    useState(null);
  const [inboundSaving, setInboundSaving] = useState(false);
  const [outboundSaving, setOutboundSaving] = useState(false);

  // Hardcoded HQ assignment by request for this use case.
  const HQ_BRANCH_ID = "iVqgep3urhVOSZEd2KBH";
  const HQ_BRANCH_NAME = "HQ";
  const isMainBranch =
    !!user &&
    user.branch === HQ_BRANCH_ID &&
    (!user.branch_name || user.branch_name === HQ_BRANCH_NAME);
  const canUseHqOutbound =
    isMainBranch &&
    (user.role == "admin" || user.role == "manager" || user.role == "warehouse");

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    if (!cameraID) {
      getCameras();
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    // console.log(scannedItems)
    if (packItems.length > 0 && scannedItems.length > 0) {
      var goods = true;
      packItems.map((item) => {
        // console.log(item)
        var currentcount = countOccurrences(scannedItems, item.product);
        // console.log(currentcount , item.quantity)
        if (currentcount < item.quantity) {
          goods = false;
        }
      });
      if (goods) {
        message.success("all scanned");
        setAllScanned(true);
        playsuccess();
        setSetProccessLoading(false);
      }
    }
  }, [scannedItems]);

  useEffect(() => {
    // console.log(scannedItems)
    if (scanLoading) {
      const debounceMs = scanMode == "hqInbound" ? 800 : 900;
      setTimeout(function () {
        setScanLoading(false);
      }, debounceMs);
    }
  }, [scanLoading, scanMode]);

  const countOccurrences = (arr, val) =>
    arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

  const getScanPayload = (value) => {
    if (!value) {
      return null;
    }

    const text = value.trim();
    const textArr = text.split("_");

    if (textArr[0] == "pck" || textArr[0] == "pckitem") {
      return {
        raw: text,
        type: textArr[0],
        id: textArr[1],
      };
    }

    if (textArr[0] == "prod") {
      return {
        raw: text,
        type: "prod",
        id: textArr[1],
      };
    }

    const packItemIds = packItems.map((item) => item.product);
    if (packItemIds.includes(text)) {
      return {
        raw: text,
        type: "prod",
        id: text,
      };
    }

    return null;
  };

  const scanChecker = (current) => {
    const payload = getScanPayload(current);

    if (payload) {
      if (payload.type == "pck" || payload.type == "pckitem") {
        var newID = payload.id;
        if (newID !== currentPackID) {
          setCurrentPackID(newID);
          if (currentPackID) {
            setScannedItems([payload.raw]);
            resetModal();
          }
        } else {
          // if(!scannedItems.includes(newID)){
          //   setScannedItems(scannedItems => [...scannedItems, text]);
          // }
        }
      }
      if (payload.type == "prod") {
        var newID = payload.id;
        var packItemsprods = packItems.map((pki) => {
          return pki.product;
        });
        if (packItemsprods.includes(newID)) {
          var currentthing = packItems.filter((pki) => pki.product == newID);
          currentthing = currentthing[0];
          if (
            parseFloat(currentthing.quantity) >
              parseFloat(currentthing.source[`${user.branch}_count`]) &&
            currentItem.dest.id !== user.branch
          ) {
            playerror();
            message.error("product warehouse quantity insufficient");
          } else {
            var scannedcount = countOccurrences(scannedItems, newID);
            // console.log(scannedcount,newID)
            if (scannedcount < currentthing.quantity) {
              setScannedItems((scannedItems) => [...scannedItems, newID]);
              message.success(
                `${currentthing.product_name} : ${scannedcount + 1} of ${
                  currentthing.quantity
                }`
              );
            } else if (scannedcount >= currentthing.quantity) {
              playerror();
              message.warning("you already have scanned the right amount");
            }
          }
        } else {
          playerror();
          message.error("product not part of list");
        }
      }
    }
  };

  useEffect(() => {
    if (currentPackID) {
      getThePackage(currentPackID);
    }
  }, [currentPackID]);

  const getCameras = () => {
    if (
      typeof navigator === "undefined" ||
      !navigator.mediaDevices ||
      typeof navigator.mediaDevices.enumerateDevices !== "function"
    ) {
      setCameras([]);
      setCameraID(null);
      return;
    }

    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        const videoSelect = [];
        devices.forEach((device) => {
          if (device.kind === "videoinput") {
            videoSelect.push(device);
          }
        });
        return videoSelect;
      })
      .then((devices) => {
        // console.log(devices)
        setCameras(devices);
        if (devices.length > 0) {
          setCameraID(devices[0].deviceId);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getThePackage = (id) => {
    dispatch(retrievePackage(id)).then((res) => {
      var dest = locations.filter((i) => i.id == res.destination);
      var destData = dest[0];
      if (destData) {
        res["dest"] = destData;
      }
      console.log(res);
      setCurrentItem(res);
    });
  };

  useEffect(() => {
    if (currentItem) {
      setIsModalVisible(true);
      // console.log(currentItem.items)
      // var sortedItems = currentItem.items.sort((a,b) =>(a?.source?.need_scan && !b?.source?.need_scan) ? 1 : ((b?.source?.need_scan && !a?.source?.need_scan) ? -1 : 0) )
      setPackItems(currentItem.items);
      var userbranch = user.branch;
      currentItem.items.map((item) => {
        if (
          item?.source?.[`${userbranch}_count`] &&
          currentItem?.status == "toPack"
        ) {
          var avaialble = item?.source?.[`${userbranch}_count`];
          if (parseFloat(avaialble) < parseFloat(item.quantity)) {
            message.error(`${item.product_name} insufficient`);
            setKulang(true);
          }
        }
      });
    }
  }, [currentItem]);

  const readyToShip = () => {
    console.log(currentItem);

    dispatch(readyShip(currentItem)).then((res) => {
      message.success("Package is Ready to Ship");
      setLoading(false);
      onCloseModal();
      closeModal();
    });
  };

  const recievePackage = () => {
    // console.log(currentItem)
    setLoading(true);
    dispatch(completePackage(currentItem)).then((res) => {
      message.success("Package Has Been Accepted");
      setLoading(false);
      onCloseModal();
      closeModal();
    });
  };

  const footer = () => {
    if (scanMode == "hqInbound" && isMainBranch) {
      return null;
    }

    return (
      <div className="cartFooter">
        {currentItem &&
        currentItem.status == "toShip" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "warehouse") ? (
          <ShipPackage
            currentItem={currentItem}
            onCloseModal={() => {
              onCloseModal();
              closeModal();
            }}
          />
        ) : null}

        {currentItem &&
        currentItem.status == "toPack" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "warehouse") ? (
          user.branch == currentItem.destination ? (
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                if (!loading) {
                  setLoading(true);
                  recievePackage();
                }
              }}
            >
              Receive Package
            </Button>
          ) : !kulang && allScanned ? (
            <Button
              type="primary"
              loading={loading}
              onClick={() => {
                if (!loading) {
                  setLoading(true);
                  readyToShip();
                }
              }}
            >
              Ready for Shipping
            </Button>
          ) : null
        ) : null}
        {currentItem &&
        currentItem.status == "shipping" &&
        (user.role == "admin" ||
          user.role == "manager" ||
          user.role == "oic") ? (
          <Button
            type="primary"
            loading={loading}
            onClick={() => {
              recievePackage();
            }}
          >
            Receive Package
          </Button>
        ) : null}

        <div className="destination"></div>
      </div>
    );
  };

  const closeModal = () => {
    setIsModalVisible(false);
    setScanMode("package");
    setCurrentScanned(null);
    setCurrentPackID(null);
    setCurrentItem(null);
    setScannedItems([]);
    setHqInboundItems({});
    setHqOutboundItems({});
    setHqOutboundDestination(null);
    setHqOutboundDestinationName(null);
    setInboundSaving(false);
    setOutboundSaving(false);
    resetModal();
  };

  const resetModal = () => {
    setPackItems([]);

    setKulang(false);
    setAllScanned(false);
  };

  const addHqInboundScan = async (text) => {
    if (!text || !isMainBranch) {
      return;
    }

    const trimmed = text.trim();
    if (!trimmed.startsWith("prod_")) {
      playerror();
      message.error("Invalid product code. Expected prod_<id>.");
      return;
    }

    const productId = trimmed.slice(5);
    if (!productId) {
      playerror();
      message.error("Invalid product code payload.");
      return;
    }

    let productData = null;
    try {
      productData = await dispatch(getProduct(productId));
    } catch (error) {
      console.error(error);
    }

    if (!productData) {
      playerror();
      message.error("Product not found.");
      return;
    }

    setHqInboundItems((prev) => {
      const current = prev[productId];
      const nextQty = (current?.quantity || 0) + 1;
      return {
        ...prev,
        [productId]: {
          id: productId,
          product_name: productData.name || productId,
          unit: productData.unit || "unit",
          quantity: nextQty,
        },
      };
    });

    playsuccess();
    message.success(`${productData.name || productId} inbound +1`);
  };

  const changeHqInboundQty = (productId, quantity) => {
    if (!productId) {
      return;
    }
    const safeQty = Math.max(0, parseFloat(quantity || 0));
    setHqInboundItems((prev) => {
      const current = prev[productId];
      if (!current) {
        return prev;
      }
      if (safeQty <= 0) {
        const next = { ...prev };
        delete next[productId];
        return next;
      }
      return {
        ...prev,
        [productId]: {
          ...current,
          quantity: safeQty,
        },
      };
    });
  };

  const removeHqInboundItem = (productId) => {
    setHqInboundItems((prev) => {
      const next = { ...prev };
      delete next[productId];
      return next;
    });
  };

  const resetHqInbound = () => {
    setHqInboundItems({});
  };

  const confirmHqInbound = async () => {
    if (!isMainBranch) {
      message.error("HQ Inbound mode is only available for HQ-assigned users.");
      return;
    }

    const inboundList = Object.values(hqInboundItems || {}).filter(
      (item) => parseFloat(item.quantity || 0) > 0
    );

    if (inboundList.length === 0) {
      message.warning("Scan at least one product to inbound.");
      return;
    }

    setInboundSaving(true);
    const reason = "hq inbound scanner";
    try {
      await Promise.all(
        inboundList.map((item) =>
          dispatch(
            setProductInventoryWithLocation(
              item.id,
              item.product_name,
              item.quantity,
              "add",
              reason,
              HQ_BRANCH_ID,
              HQ_BRANCH_NAME
            )
          )
        )
      );
      message.success("HQ inbound confirmed and inventory updated.");
      setHqInboundItems({});
      closeModal();
      onCloseModal();
    } catch (error) {
      console.error(error);
      message.error("Failed to confirm HQ inbound.");
    } finally {
      setInboundSaving(false);
    }
  };

  const addHqOutboundScan = async (text) => {
    if (!text || !canUseHqOutbound) {
      return;
    }

    const trimmed = text.trim();
    if (!trimmed.startsWith("prod_")) {
      playerror();
      message.error("Invalid product code. Expected prod_<id>.");
      return;
    }

    const productId = trimmed.slice(5);
    if (!productId) {
      playerror();
      message.error("Invalid product code payload.");
      return;
    }

    let productData = null;
    try {
      productData = await dispatch(getProduct(productId));
    } catch (error) {
      console.error(error);
    }

    if (!productData) {
      playerror();
      message.error("Product not found.");
      return;
    }

    setHqOutboundItems((prev) => {
      const current = prev[productId];
      const nextQty = (current?.quantity || 0) + 1;
      return {
        ...prev,
        [productId]: {
          id: productId,
          product_name: productData.name || productId,
          unit: productData.unit || "unit",
          quantity: nextQty,
        },
      };
    });

    playsuccess();
    message.success(`${productData.name || productId} outbound +1`);
  };

  const changeHqOutboundDestination = (branchId, option) => {
    setHqOutboundDestination(branchId);
    setHqOutboundDestinationName(option?.label || null);
  };

  const changeHqOutboundQty = (productId, quantity) => {
    if (!productId) {
      return;
    }
    const safeQty = Math.max(0, parseFloat(quantity || 0));
    setHqOutboundItems((prev) => {
      const current = prev[productId];
      if (!current) {
        return prev;
      }
      if (safeQty <= 0) {
        const next = { ...prev };
        delete next[productId];
        return next;
      }
      return {
        ...prev,
        [productId]: {
          ...current,
          quantity: safeQty,
        },
      };
    });
  };

  const removeHqOutboundItem = (productId) => {
    setHqOutboundItems((prev) => {
      const next = { ...prev };
      delete next[productId];
      return next;
    });
  };

  const resetHqOutbound = () => {
    setHqOutboundItems({});
  };

  const confirmHqOutbound = async () => {
    if (!canUseHqOutbound) {
      message.error("HQ Outbound mode is only available for HQ admin, manager, and warehouse users.");
      return;
    }

    if (!hqOutboundDestination || !hqOutboundDestinationName) {
      message.warning("Select the destination branch first.");
      return;
    }

    const outboundList = Object.values(hqOutboundItems || {}).filter(
      (item) => parseFloat(item.quantity || 0) > 0
    );

    if (outboundList.length === 0) {
      message.warning("Scan at least one product to outbound.");
      return;
    }

    setOutboundSaving(true);
    try {
      await dispatch(
        createPackageFromItems(
          {
            destination: hqOutboundDestination,
            destination_name: hqOutboundDestinationName,
            status: "toPack",
            hq_outbound: true,
          },
          outboundList
        )
      );
      message.success("HQ outbound package created.");
      setHqOutboundItems({});
      setHqOutboundDestination(null);
      setHqOutboundDestinationName(null);
      closeModal();
      onCloseModal();
    } catch (error) {
      console.error(error);
      message.error("Failed to create HQ outbound package.");
    } finally {
      setOutboundSaving(false);
    }
  };

  const somethingScanned = (event) => {
    var text = event.text;
    setScanLoading(true);
    // console.log(text)

    if (text) {
      if (scanMode == "hqInbound") {
        if (!isMainBranch) {
          message.error("HQ Inbound mode is only available for HQ-assigned users.");
          return;
        }
        addHqInboundScan(text);
        return;
      }

      if (scanMode == "hqOutbound") {
        if (!canUseHqOutbound) {
          message.error("HQ Outbound mode is only available for HQ admin, manager, and warehouse users.");
          return;
        }
        addHqOutboundScan(text);
        return;
      }

      const payload = getScanPayload(text);

      if (payload) {
        // message.success(`scanned ${textArr.join(' ')}`)
        playbeep();
        if (payload.type == "prod" && currentItem == null) {
          playerror();
          message.error("Scan Package Waybill First");
        } else {
          setCurrentScanned(text);
          scanChecker(text);
        }
      }
    }
  };

  const packthisItem = (item) => {
    var newArr = [];
    for (let i = 0; i < item.quantity; i++) {
      newArr.push(item.product);
    }
    playbeep();
    setScannedItems((scannedItems) => [...scannedItems, ...newArr]);
  };

  const packthisScannedItem = (item, currentscannedqty) => {
    var newArr = [];
    var qty = item.quantity - currentscannedqty;
    for (let i = 0; i < qty; i++) {
      newArr.push(item.product);
    }
    playbeep();
    setScannedItems((scannedItems) => [...scannedItems, ...newArr]);
  };

  const thiscamera = () => {
    return cameraID;
  };

  const iOS = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };

  const changeScanMode = (nextMode) => {
    if (nextMode == "hqInbound" && !isMainBranch) {
      message.error("HQ Inbound mode is only available for HQ-assigned users.");
      return;
    }
    if (nextMode == "hqOutbound" && !canUseHqOutbound) {
      message.error(
        "HQ Outbound mode is only available for HQ admin, manager, and warehouse users."
      );
      return;
    }
    setScanMode(nextMode);
  };

  return (
    <>
      {showButton ? (
        <div className={"scanButton"}>
          <Button
            onClick={() => {
              setIsModalVisible(true);
            }}
            type={"primary"}
            shape={"round"}
            icon={<QrcodeOutlined />}
          >
            Scan QR
          </Button>
        </div>
      ) : (
        <div
          onClick={() => {
            setIsModalVisible(true);
          }}
        >
          SCAN
        </div>
      )}

      {isModalVisible ? (
        <Modal
          title={"SCAN QR"}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
          }}
        >
          <div className="cart-content">
            <div className="scanModeSwitch">
              <Button
                type={scanMode == "package" ? "primary" : "default"}
                onClick={() => {
                  changeScanMode("package");
                }}
              >
                Package Scan
              </Button>
              {isMainBranch ? (
                <Button
                  type={scanMode == "hqInbound" ? "primary" : "default"}
                  onClick={() => {
                    changeScanMode("hqInbound");
                  }}
                >
                  HQ Inbound
                </Button>
              ) : null}
              {canUseHqOutbound ? (
                <Button
                  type={scanMode == "hqOutbound" ? "primary" : "default"}
                  onClick={() => {
                    changeScanMode("hqOutbound");
                  }}
                >
                  HQ Outbound
                </Button>
              ) : null}
            </div>
            <select
              onChange={(e) => {
                setCameraID(e.target.value);
              }}
            >
              {cameras.map((cam, index) => {
                return (
                  <React.Fragment key={cam.deviceId}>
                    <option value={cam.deviceId}>
                      {cam.label || `camera ${index}`}
                    </option>
                  </React.Fragment>
                );
              })}
            </select>
            <QRcomponent
              width={width}
              cameraID={thiscamera()}
              onScan={(e) => {
                if (e && !scanLoading) {
                  somethingScanned(e);
                }
              }}
            />
            {scanMode == "package" ? (
              <>
            {currentItem ? (
              <div
                className={
                  scannedItems.includes(`pck_${currentItem.id}`) &&
                  currentItem.status == "toPack"
                    ? "orderTitleCard scanned"
                    : "orderTitleCard"
                }
              >
                <div className={"firspart"}>
                  <div className={"desc"}>
                    <span className={"label"}>Order Id:</span>{" "}
                    <span className={"val"}> {currentItem.id} </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Contact Person: </span>{" "}
                    <span className={"val"}>
                      {currentItem.dest.contact_person}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Contact No: </span>{" "}
                    <span className={"val"}>{currentItem.dest.contactno}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Destination: </span>{" "}
                    <span className={"val"}>{currentItem.dest.name}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Address: </span>{" "}
                    <span className={"val"}>{currentItem.dest.address}</span>
                  </div>
                </div>
                <div className={"qtypart"}>
                  <span>Status</span>
                  <h3>{camelToSentence(currentItem.status)}</h3>
                  <span>Items</span>
                  <h1>{currentItem.items.length}</h1>
                </div>
              </div>
            ) : null}
            {currentItem &&
            (currentItem.status == "shipping" ||
              currentItem.status == "completed") ? (
              <div className={"orderTitleCard"}>
                <div className={"firspart"}>
                  <div className={"desc"}>
                    <span className={"label"}>Courrier:</span>{" "}
                    <span className={"val"}>
                      {" "}
                      {currentItem.shipping_method_name}{" "}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Driver: </span>{" "}
                    <span className={"val"}>{currentItem.shipping_driver}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Driver Phone: </span>{" "}
                    <span className={"val"}>
                      {currentItem.shipping_contact}
                    </span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Plate no: </span>{" "}
                    <span className={"val"}>{currentItem.shipping_plate}</span>
                  </div>
                  <div className={"desc"}>
                    <span className={"label"}>Tracking: </span>
                    <a
                      href={currentItem.shipping_url}
                      target="_blank"
                      className={"val"}
                      rel="noreferrer"
                    >
                      Click Here
                    </a>
                  </div>
                </div>
                <div className={"qtypart"}>
                  <span>Shipping Fee</span>

                  <h1>{currentItem.shipping_fee}</h1>
                </div>
              </div>
            ) : null}
            <Divider orientation="left">Items</Divider>

            <List
              className="demo-loadmore-list"
              itemLayout="horizontal"
              dataSource={packItems}
              renderItem={(item) => {
                var userbranch = user.branch;
                var error = false;
                var missing = false;
                var complete = false;

                if (
                  item?.source?.[`${userbranch}_count`] &&
                  currentItem?.status == "toPack"
                ) {
                  var avaialble = item?.source[`${userbranch}_count`];
                  avaialble = parseFloat(avaialble);
                  if (
                    avaialble < item?.quantity &&
                    currentItem.dest.id !== user.branch
                  ) {
                    error = true;
                  }
                }

                var currentCount = countOccurrences(scannedItems, item.product);
                if (currentItem.status == "toPack") {
                  if (currentCount > 0 && currentCount < item.quantity) {
                    missing = true;
                  }
                  if (currentCount == item.quantity) {
                    complete = true;
                  }
                }

                var needScan = false;
                if (!item.source) {
                  console.log(item);
                }
                // if(item.source.need_scan){
                //   needScan =true
                // }

                return (
                  <List.Item
                    className={
                      error
                        ? "kulang"
                        : missing
                        ? "missing"
                        : complete
                        ? "scanned"
                        : ""
                    }
                    actions={
                      [
                        // <Button type='link' onClick={()=>{deleteThis(item.id)}}>
                        //   <DeleteOutlined  />
                        // </Button>
                      ]
                    }
                  >
                    <List.Item.Meta
                      avatar={
                        <ImageChecker
                          url={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                          success={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}${item.product}.png`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                          fail={
                            <img
                              src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                              alt="image"
                              className={"prodimage"}
                            />
                          }
                        />
                      }
                      title={item.product_name}
                      description={
                        <div className="itemdesc">
                          {item?.source?.sku ? (
                            <span>{item.source.sku}</span>
                          ) : null}
                          {avaialble &&
                          (user.role == "admin" ||
                            user.role == "manager" ||
                            user.role == "warehouse") ? (
                            <span>
                              available:{" "}
                              {numberWithCommas(avaialble.toFixed(2))}
                            </span>
                          ) : null}
                        </div>
                      }
                    />
                    {currentItem.status == "toPack" &&
                    user.branch !== currentItem.destination ? (
                      needScan ? (
                        <div className="horizontal">
                          <div className="qtyItem">
                            <h1>
                              {currentCount}/{item.quantity}
                            </h1>
                            <span>
                              {item.unit}
                              {item.quantity > 1 ? "s" : ""}
                            </span>
                          </div>
                          {currentCount > 0 ? (
                            <div className="qtyItem">
                              <Button
                                type={
                                  currentCount >= item.quantity
                                    ? "dashed"
                                    : "primary"
                                }
                                size={"large"}
                                onClick={() => {
                                  if (
                                    currentCount < item.quantity &&
                                    !setProccessloading
                                  ) {
                                    setSetProccessLoading(true);
                                    packthisScannedItem(item, currentCount);
                                  }
                                }}
                              >
                                {currentCount >= item.quantity
                                  ? "Packed"
                                  : "Pack"}
                              </Button>
                            </div>
                          ) : null}
                        </div>
                      ) : (
                        <div className="horizontal">
                          <div className="qtyItem">
                            <h1>{item.quantity}</h1>
                            <span>
                              {item.unit}
                              {item.quantity > 1 ? "s" : ""}
                            </span>
                          </div>
                          {error ? null : (
                            <div className="qtyItem">
                              <Button
                                type={complete ? "dashed" : "primary"}
                                size={"large"}
                                onClick={() => {
                                  if (!complete) {
                                    packthisItem(item);
                                  }
                                }}
                              >
                                {complete ? "Packed" : "Pack"}
                              </Button>
                            </div>
                          )}
                        </div>
                      )
                    ) : (
                      <div className="qtyItem">
                        <h1>{item.quantity}</h1>
                        <span>
                          {item.unit}
                          {item.quantity > 1 ? "s" : ""}
                        </span>
                      </div>
                    )}
                    {/* <div className="vertical">
                    <InputNumber min={0} size={'large'} defaultValue={item.quantity} onChange={(e)=>{changeCartCount(item.id,e)}}  />
                    <span>{item.unit}</span>
                  </div> */}
                  </List.Item>
                );
              }}
            />
              </>
            ) : scanMode == "hqInbound" ? (
              <HQInboundScanner
                inboundItems={hqInboundItems}
                onChangeQty={changeHqInboundQty}
                onRemove={removeHqInboundItem}
                onClear={resetHqInbound}
                onConfirm={confirmHqInbound}
                loading={inboundSaving}
              />
            ) : (
              <HQOutboundScanner
                outboundItems={hqOutboundItems}
                locations={locations}
                destination={hqOutboundDestination}
                onDestinationChange={changeHqOutboundDestination}
                onChangeQty={changeHqOutboundQty}
                onRemove={removeHqOutboundItem}
                onClear={resetHqOutbound}
                onConfirm={confirmHqOutbound}
                loading={outboundSaving}
                hqBranchId={HQ_BRANCH_ID}
              />
            )}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
